
import { Ref } from "vue";
import { ElMessageBox } from 'element-plus';
import { ElMessage } from 'element-plus';
import { ElNotification } from 'element-plus'
import { Actions } from "@/store/enums/StoreEnums";
import store from "@/store";
import router from '@/router';
import moment from "moment";
import {ProgressFinisher, useProgress} from '@marcoschulte/vue3-progress';
import axios from "axios";
moment.locale("es");
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import GlobalService from "../services/GlobalService";


export const errManager = (response: any, target = null, mode = 1) => {
    if (!response)
        ElMessage({ showClose: true, message: 'Oops, no se ha recibido información del error para ser procesado.', type: 'error' })

    const status = response.status
    const title = (status === 401) ? "Seguridad del Sistema" : `Error ${response.status} [${response.statusText}]`
    let message = ''

    if(status === 403) //acceso prohibido
       return router.push("/403")

    if (status === 401) {
        message = response.statusText
    } else if (typeof response.data == 'string') {
        message = response.data
    } if (typeof response.data === 'object') {
        if (Object.prototype.hasOwnProperty.call(response.data, 'message'))
            message = response.data.message
        else if (Object.prototype.hasOwnProperty.call(response.data, 'messages'))
            message = response.data.messages.error
        else if (Object.prototype.hasOwnProperty.call(response, 'messages'))
            message = response.messages.error
        else
            message = 'No se tiene información del error.'
    }

    if(mode == 1)
        ElMessageBox.alert(message, title, {
            type: 'warning',
            confirmButtonText: 'Entendido',
            dangerouslyUseHTMLString: true,
            callback: action => {
                if (status === 401){
                    store
                        .dispatch(Actions.LOGOUT)
                        .then(() => {
                            router.push("/sign-in")
                        });
                }   
            }
        })

    if(mode == 2)
        ElNotification({
            title: title,
            message: message,
            type: 'warning',
            customClass: 'custom bg-danger',
            duration: 3000 
        })
        
}

export const showNotification = (data: { 
    title?: string; 
    message?: string; 
    status?: 'success' | 'warning' | 'info' | 'error' 
}) => { 
    try {
        // Convertimos 'danger' a 'error' para que sea válido
        const statusType = data.status === 'error' ? 'danger' : data.status;

        ElNotification({
            title: data.title || 'Notificación',
            message: data.message || 'Ocurrió un error inesperado.',
            type: data.status, // Aseguramos que sea un tipo válido
            customClass: `custom bg-${statusType}`,
            dangerouslyUseHTMLString: true,
            duration: 3000 // Puedes ajustar la duración,
        });
    } catch (error) {
        console.error('Error mostrando notificación:', error);
    }
};

export const dateParticipate = (date1: any, date2: any) => {
    if (date1 && date2) {
      let dat1 = moment(date1).format("DD MMM");
      let dat2 =
        moment(date1).format("DD/MM/YYYY") !=
        moment(date2).format("DD/MM/YYYY")
          ? " al " + moment(date2).format("DD MMM YYYY")
          : "";

      return dat1 + `<span>${dat2}</span>`;
    } else {
      return "Sin información";
    }
};

export const mbtoa = (value) => {
    return btoa(value)
}

export const DownloadXLSXPDF = (ext, target, payload) => {
    const progresses = [] as ProgressFinisher[];
    progresses.push(useProgress().start());
    let params = new URLSearchParams(payload);
    axios({
        url: process.env.VUE_APP_API_URL + `/${ext}/${target}?${params}`,
        method: 'GET',
        responseType: 'blob',
    }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fURL = document.createElement('a');
        var nameFile = moment().format() + "." +ext

        fURL.href = fileURL;
        fURL.setAttribute('download', nameFile);
        document.body.appendChild(fURL);
        fURL.click();
        progresses.pop()?.finish();
    }).catch( (err) => {
        progresses.pop()?.finish();
        errManager(err)
    })
}

/**
 * Descarga un archivo (XLSX o PDF) desde el backend y muestra alertas.
 * @param ext - Extensión del archivo ("xlsx" o "pdf")
 * @param target - Endpoint o ruta de la API (ej. "reportes/usuarios")
 * @param payload - Parámetros de consulta (query params)
 * @param loaderRef - ref<boolean> opcional para mostrar loader
 */
export const DownloadFile = async(
        ext: string, 
        target: string, 
        payload: Record<string, any>,
        loaderRef?: Ref<boolean>
    ) => {
    if (loaderRef) loaderRef.value = true;
    const progresses = [] as ProgressFinisher[];
    progresses.push(useProgress().start());
    let params = new URLSearchParams(payload);
    axios({
        url: process.env.VUE_APP_API_URL + `/${ext}/${target}?${params}`,
        method: 'GET',
        responseType: 'blob',
    }).then((response) => {
        const disposition = response.headers["content-disposition"];
        var nameFile = `${moment().format("YYYYMMDD_HHmmss")}.${ext}`

        console.log(Object.keys(response.headers));
        console.log(response.headers);

        if (disposition) {
            const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (match && match[1]) {
                nameFile = decodeURIComponent(match[1].replace(/['"]/g, ""));
            }
        }

        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fURL = document.createElement('a');

        fURL.href = fileURL;
        fURL.setAttribute('download', nameFile);
        document.body.appendChild(fURL);
        fURL.click();

        fURL.remove();
        window.URL.revokeObjectURL(fileURL);
        progresses.pop()?.finish();
    }).catch( (err) => {
        if (loaderRef) loaderRef.value = false;
        progresses.pop()?.finish();
        errManager(err)
    }).finally(()=>{
        if (loaderRef) loaderRef.value = false;
        progresses.pop()?.finish();
    });
}

export const showMessage = (data) => { 

    const className = data.status == 'error' ? 'danger' : data.status

    Swal.fire({
        title: data.title,
        html: data.message,
        icon: data.status,
        buttonsStyling: false,
        allowOutsideClick: false,
        confirmButtonText: "Entendido",
        customClass: {
            confirmButton: `btn fw-bold btn-light-${className}`,
        },
    })
}

export const validFormatImg = (data) : boolean => {
    const allowedFormats = ['image/jpeg', 'image/jpg', 'image/png'];
    return allowedFormats.includes(data);
}

export const validFormatImgPDF = (data) : boolean => {
    const allowedFormats = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
    return allowedFormats.includes(data);
}

export const cBoolean = (val) : boolean => {
    return val === "1"
}

interface ConfirmDeleteParams {
  module: string
  id: string | number
  name?: string,
  payload?: Record<string, any>
  onSuccess?: () => void
  t: Function
}

export const confirmDelete = async ({
    module,
    id,
    name,
    payload = { mstatus: 0 },
    onSuccess,
    t,
}: ConfirmDeleteParams) => {
    await Swal.fire({
        title: t('deleteRecord'),
        html: t('deleteText', { text: name ?? '' }),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: t('delete'),
        cancelButtonText: t('cancel'),
        confirmButtonColor: '#d33',
        showLoaderOnConfirm: true,
        reverseButtons: true,
        allowOutsideClick: false,
        preConfirm: async () => {
            return GlobalService.delete(module, `${id}/delete`, payload)
                .then((res) => {
                    return res.data
                })
                .catch(({ response }) => {
                Swal.showValidationMessage(
                    `Request failed: ${response?.data?.message || response}`
                )
            });
        }
  }).then((result) => {
        showNotification(result.value)
        if (result.isConfirmed && result.value) {
            result.value.status === 'success' && onSuccess?.()
        }
  })
} 
